(function () {
    'use strict';

    var imageSliders = document.querySelectorAll('.hero-slider');

    function checkArrows(swiper) {
        if (swiper.isBeginning && swiper.isEnd) {
            $(swiper.navigation.prevEl).addClass('hide-prevnext');
            $(swiper.navigation.nextEl).addClass('hide-prevnext');
        } else {
            $(swiper.navigation.prevEl).removeClass('hide-prevnext');
            $(swiper.navigation.nextEl).removeClass('hide-prevnext');
        }
    }

    for (var i = 0; i < imageSliders.length; i++) {
        var swiperContainer =
            imageSliders[i].querySelector('.swiper');

        new Swiper(swiperContainer, {
            slidesPerView: 1,
            watchOverflow: true,
            effect: 'fade',
            allowTouchMove: false,
            autoplay: {
                delay: 4000,
            },
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },
            on: {
                afterInit: function () {
                    checkArrows(this);
                    swiperContainer.querySelector(
                        '.slider-progress'
                    ).style.width = `${
                        100 -
                        ((this.activeIndex + 1) / this.slides.length) * 100
                    }%`;
                },
                resize: function () {
                    checkArrows(this);
                },
                slideChange: function () {
                    swiperContainer.querySelector(
                        '.slider-progress'
                    ).style.width = `${
                        100 -
                        ((this.activeIndex + 1) / this.slides.length) * 100
                    }%`;
                },
            },
        });
    }
})();

// Handle FSllightbox video popups
(function () {
  var trigger = document.getElementById('open-video');
  if (!trigger) return;

  function buildIframe(src) {
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('width', '1280');
    iframe.setAttribute('height', '720');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    return iframe;
  }

  trigger.addEventListener('click', function (e) {
    e.preventDefault();

    var provider = (trigger.getAttribute('data-video-provider') || '').toLowerCase();
    var src = trigger.getAttribute('data-video-src');
    if (!src) { console.error('No video src on trigger.'); return; }
    if (typeof FsLightbox === 'undefined') { console.error('FsLightbox script not found.'); return; }

    var box = new FsLightbox();

    // Default: let FsLightbox handle supported URLs (YouTube, direct mp4/webm/ogg)
    if (provider === 'youtube') {
      box.props.sources = [src];
      box.props.types = ['youtube'];
    } else if (provider === 'video') {
      box.props.sources = [src];
      box.props.types = ['video'];
    } else if (provider === 'vimeo') {
      // Vimeo needs a custom iframe each time
      box.props.sources = [buildIframe(src)];
    } else {
      // Unknown provider: try URL first; if it fails in your context, switch to iframe
      box.props.sources = [src];
      // Optionally force iframe fallback:
    }
    box.open();
  });
})();
